module.exports = __webpack_public_path__ + "img/custom_avatar.ee5b8f1a.svg";